import React from 'react';

/**
 * The Item component is used by ButtonGroup to help display the child elements.
 *
 * @param { React.ReactElement } button -> The Button to be displayed in the
 *                                         ButtonGroup component.
 */
export default function Item({ button }) {
  return (
    <>
      {button}
    </>
  );
}
